export default __webpack_public_path__ + "static/AffordableDialog-e98d0a7d28ccd5324ad7a3f12191a75d.png";